import React from 'react';
import { connect } from 'dva';
import ExportDetailModal from 'components_business/ExportDetailModal/Index.js';

@connect(({ merchantCommodity, loading }) => ({
  modal: merchantCommodity.modal,
  modalLoading:
    loading.effects['merchantCommodity/fetchRelateSchools'] ||
    loading.effects['merchantCommodity/export'],
}))
export default class ExportModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleExportDetailModalOnCancel = this.handleExportDetailModalOnCancel.bind(this);
    this.handleExportDetailModalOnOk = this.handleExportDetailModalOnOk.bind(this);
    this.hideExportDetailModal = this.hideExportDetailModal.bind(this);
  }

  handleExportDetailModalOnCancel() {
    this.hideExportDetailModal();
  }

  handleExportDetailModalOnOk(values) {
    const { modal } = this.props;

    this.props
      .dispatch({
        type: 'merchantCommodity/export',
        id: modal.rowData.commodityId,
        orgId: values.orgId,
        startDate: values.startDate,
        endDate: values.endDate,
      })
      .then(() => {
        this.hideExportDetailModal();
      });
  }

  hideExportDetailModal() {
    this.props.dispatch({
      type: 'merchantCommodity/toggleModalVisibility',
      modal: { exportDetailVisible: false },
    });
  }

  render() {
    const { modalLoading, modal: { exportDetailVisible, relateSchools } } = this.props;

    return (
      <ExportDetailModal
        relateSchools={relateSchools}
        loading={modalLoading}
        visible={exportDetailVisible}
        onCancel={this.handleExportDetailModalOnCancel}
        onOk={this.handleExportDetailModalOnOk}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Commodity/Modal/Export.js